class Buttons {
	private resizeTimeout = 0;
	private observer: MutationObserver | null = null;

	init(): void {
		document.addEventListener('DOMContentLoaded', () => this.detectButtonTextWrap());
		window.addEventListener('resize', () => this.handleResize());
		this.detectButtonTextWrap();
		this.observeTabVisibility();
	}

	private detectButtonTextWrap(): void {
		const buttons = document.querySelectorAll('a.btn-primary, a.btn-secondary, a.btn-tertiary');

		buttons.forEach((button) => {
			const wordSpans = button.querySelectorAll('.btn-words');
			if (wordSpans.length === 0) return;

			// Check if word spans are on different lines by comparing their offsetTop values
			const firstTop = (wordSpans[0] as HTMLElement).offsetTop;
			const isWrapping = Array.from(wordSpans).some(
				(span) => (span as HTMLElement).offsetTop > firstTop
			);

			if (isWrapping) {
				button.classList.add('btn-text-wrap');
			} else {
				button.classList.remove('btn-text-wrap');
			}
		});
	}

	private handleResize(): void {
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = window.setTimeout(() => this.detectButtonTextWrap(), 150);
	}

	private observeTabVisibility(): void {
		this.observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
					const target = mutation.target as HTMLElement;

					// Check if element became visible (display changed from none)
					if (target.style.display !== 'none' && target.offsetParent !== null) {
						// Re-detect button wrapping for buttons within this element
						this.detectButtonTextWrap();
					}
				}
			});
		});

		// Observe all tab panels for style and class changes
		const tabPanels = document.querySelectorAll('.block-tab__collapsable, .block-tab');
		tabPanels.forEach((panel) => {
			this.observer?.observe(panel, {
				attributes: true,
				attributeFilter: ['style', 'class'],
			});
		});
	}
}

export default new Buttons();
